import { FC } from 'react'
import { Link, Typography } from '@mui/material'
import { colorTokens } from '../../../shared/styles/colorTokens'
import { typeScale } from '../../../shared/styles/typography'

const SUPPORT_EMAIL = 'support@medilab.co.jp'

/**
 * メール本文の雛形。escalation.md の伝える項目（必ず3点・分かれば2点）と
 * 同じ順・同じ言葉にすること（項目 = CS 起票フィールドの写像。md 側を直したらここも直す）。
 */
const MAILTO_HREF = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
  'まもる君についての問い合わせ'
)}&body=${encodeURIComponent(
  [
    '店舗名：',
    'このページで試した手順（例：Bの2まで）：',
    '起きたおおよその日時：',
    '画面に表示されているメッセージ（分かれば）：',
    'サポートコード（Request ID の末尾4桁・分かれば）：',
  ].join('\r\n')
)}`

/**
 * 直販（/guide）の「解決しないとき」の連絡先。support@medilab.co.jp へのメールが一次窓口。
 *
 * mailto はアドレスのインラインリンクに留める（店頭PCはメーラ未設定が普通で、押下前提の
 * ボタンにすると環境依存で壊れる。リンクならメーラがある環境でだけ雛形付きで開き、
 * 無くても文章として成立する）。
 *
 * 法人版（welcia / aisei）の窓口は各 variant の ContactNote が持つ。
 * ログイン中の店舗がどの版に着くかは back が決めるので、ここで閲覧者を判定しない
 * （hub design-book ADR-0051）。
 */
export const EscalationContact: FC = () => (
  <Typography sx={{ ...typeScale.body, my: 1 }}>
    サポート窓口（
    <Link
      href={MAILTO_HREF}
      underline="none"
      sx={{ color: colorTokens.accent.primary }}
    >
      {SUPPORT_EMAIL}
    </Link>
    ）へメールでご連絡ください。
  </Typography>
)
